import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/HealthCoachSlice";

import { constants } from "../../constants/common";
import { common } from "../../types";

import API from "../../services/rest/api";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';

const GetHealthCoachDetailsRequest = function* GetHealthCoachDetailsRequest({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.GetProfileDetails
    );
    if (Number(response.code) === 1) {
      yield put(actions.getHealthCoachDetailsSuccess(response));
      resolve(response);
    } else if (Number(response.code) === -1) {
      const ErrorMessage = "Session Expire";
      yield put(
        actions.getHealthCoachDetailsError(
          ErrorMessage
        )
      );
      toast.error(ErrorMessage);
    } else {
      const ErrorMessage = response.message || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      yield put(actions.getHealthCoachDetailsError(ErrorMessage));
      toast.error(ErrorMessage);
    }
  } catch (error) {
    const ErrorMessage = error instanceof Error
      ? error?.message
      : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(
      actions.getHealthCoachDetailsError(
        ErrorMessage
      )
    );
    toast.error(ErrorMessage);
    // reject(error);
  }
};

const ScheduleCycleRequest = function* ScheduleCycleRequest(
  action: PayloadAction<any>
) {
  try {
    const { isForBulkProcess, ...body } = action.payload || {};
    const response: common.ResponseGenerator = yield call(
      API.ScheduleVisitDetails,
      body
    );
    if (Number(response.code) === 1) {
      yield put(actions.scheduleCycleSuccess(response));
      if (isForBulkProcess) {
        toast.success("Bulk creation process completed successfully");
      } else {
        toast.success(response.message || "Session created successfully");
      }
    } else {
      const ErrorMessage = response.message || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      yield put(
        actions.scheduleCycleError(
          ErrorMessage
        )
      );
      toast.error(ErrorMessage);
    }
  } catch (error) {
    const ErrorMessage = error instanceof Error
      ? error?.message
      : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(
      actions.scheduleCycleError(
        ErrorMessage
      )
    );
    toast.error(ErrorMessage);
  }
};

const UpdateVisitDetailsRequest = function* UpdateVisitDetailsRequest(
  action: PayloadAction<any>
) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.UpdateVisitDetails,
      action.payload
    );
    if (Number(response.code) === 1) {
      yield put(actions.updateVisitDetailsSuccess(response));
      toast.success(response.message || "Session updated successfully");
    } else {
      const ErrorMessage = response.message || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      yield put(
        actions.updateVisitDetailsError(
          ErrorMessage
        )
      );
      toast.error(ErrorMessage);
    }
  } catch (error) {
    const ErrorMessage = error instanceof Error
      ? error?.message
      : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(
      actions.updateVisitDetailsError(
        ErrorMessage
      )
    );
    toast.error(ErrorMessage);
  }
};

const BulkScheduleVisitDetailsRequest =
  function* BulkScheduleVisitDetailsRequest(action: PayloadAction<any>) {
    try {
      const response: common.ResponseGenerator = yield call(
        API.BulkScheduleVisitDetails,
        action.payload
      );
      if (Number(response.code) === 1) {
        yield put(actions.bulkScheduleVisitDetailsSuccess(response));
        //toast.success(response.message || "Bulk Sessions created successfully");
      } else {
        const ErrorMessage = response.message || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
        yield put(
          actions.bulkScheduleVisitDetailsError(
            ErrorMessage
          )
        );
        toast.error(ErrorMessage);
      }
    } catch (error) {
      const ErrorMessage = error instanceof Error
        ? error?.message
        : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      yield put(
        actions.bulkScheduleVisitDetailsError(
          ErrorMessage
        )
      );
      toast.error(
        ErrorMessage
      );
    }
  };

const GetPatientVisitDetailsRequest = function* GetPatientVisitDetailsRequest(
  action: PayloadAction<any>
) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.GetPatientVisitDetails,
      action.payload
    );
    if (Number(response.code) === 1) {
      yield put(actions.getPatientVisitDetailsSuccess(response));
    } else {
      yield put(
        actions.getPatientVisitDetailsError(
          response.message || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
        )
      );
    }
  } catch (error) {
    yield put(
      actions.getPatientVisitDetailsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

const BulkUploadPatientRecordsRequest = function* BulkUploadPatientRecordsRequest(
  action: PayloadAction<{
    formData: FormData;
    silent?: boolean;
    resolve?: (value?: unknown) => void;
    reject?: (reason?: unknown) => void;
  }>
) {
  const { formData, silent, resolve, reject } = action.payload;
  try {
    const response: common.ResponseGenerator = yield call(
      API.BulkUploadPatientRecords,
      formData
    );
    if (Number(response.code) === 1) {
      yield put(actions.bulkUploadPatientRecordsSuccess(response));
      if (!silent) {
        toast.success(
          response.message || "Patient records uploaded successfully"
        );
      }
      resolve?.(response);
    } else {
      const errorMessage =
        response.message || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      yield put(actions.bulkUploadPatientRecordsError(errorMessage));
      if (!silent) {
        toast.error(errorMessage);
      }
      reject?.(new Error(errorMessage));
    }
  } catch (error) {
    const ErrorMessage =
      error instanceof Error
        ? error?.message
        : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(actions.bulkUploadPatientRecordsError(ErrorMessage));
    if (!silent) {
      toast.error(ErrorMessage);
    }
    reject?.(error);
  }
};

export default function* dietSaga() {
  yield all([
    takeEvery(
      actions.getHealthCoachDetailsRequest,
      GetHealthCoachDetailsRequest
    ),
    takeEvery(actions.scheduleCycleRequest, ScheduleCycleRequest),
    takeEvery(actions.updateVisitDetailsRequest, UpdateVisitDetailsRequest),
    takeEvery(actions.bulkScheduleVisitDetailsRequest, BulkScheduleVisitDetailsRequest),
    takeEvery(actions.getPatientVisitDetailsRequest, GetPatientVisitDetailsRequest),
    takeEvery(actions.bulkUploadPatientRecordsRequest, BulkUploadPatientRecordsRequest),
  ]);
}
